module.exports = __webpack_public_path__ + "img/hj_4.d4061efa.jpg";